import { render, staticRenderFns } from "./TableHead.vue?vue&type=template&id=37bf7abc&scoped=true&"
import script from "./TableHead.vue?vue&type=script&lang=js&"
export * from "./TableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf7abc",
  null
  
)

export default component.exports